<template>
  <form @submit.prevent="onSubmit">
    <h3 class="mb-4">Custom HTML Header</h3>
    <p>
      Code entered here will be placed before the closing &lt;/head&gt; tag on all landing pages. This is a good spot
      for scripts like Facebook Pixel or Google Ads Tag.
    </p>

    <code-editor
      :id="'code-editor-header'"
      class="mb-4"
      :content="vesselHeaderCode"
      @content-change="onHeaderCodeChange($event)"
    ></code-editor>

    <h3 class="mt-5 mb-4">Custom HTML Footer</h3>
    <p>Code entered here will be placed before the closing &lt;/body&gt; tag on all landing pages.</p>

    <code-editor
      :id="'code-editor-footer'"
      class="mb-4"
      :content="vesselFooterCode"
      @content-change="onFooterCodeChange($event)"
    ></code-editor>

    <p>You can override any of these values for a specific landing page in its Advanced Settings.</p>

    <button type="submit" class="btn btn-primary btn-lg mt-3" :disabled="disabled">
      <img v-if="loading" src="/wp-content/themes/snappy-theme/assets/images/loading2.gif" class="loading-image" />
      <span>Save changes</span>
    </button>
  </form>
</template>

<script>
import CodeEditor from '../components/editor/CodeEditor';
import utils from '../mixins/utils';
import {getVessel} from '../utility/api/vessel/getVessel';
import {updateVessel} from '../utility/api/vessel/updateVessel';

export default {
  name: 'account-landing-pages-page',
  components: {CodeEditor},
  data() {
    return {
      headerCode: '',
      footerCode: '',
      loading: false,
      vessel: null,
    };
  },
  props: {
    profileLocked: {
      type: Boolean,
      required: true,
      default: false,
    },
    profileApproved: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    disabled() {
      if (this.profileLocked) {
        return true;
      }

      return this.loading || (this.headerCode === this.vesselHeaderCode && this.footerCode === this.vesselFooterCode);
    },
    vesselHeaderCode() {
      return (this.vessel && this.vessel.custom_scripts_head) || '';
    },
    vesselFooterCode() {
      return (this.vessel && this.vessel.custom_scripts_footer) || '';
    },
  },
  methods: {
    onHeaderCodeChange(code) {
      this.headerCode = code;
    },
    onFooterCodeChange(code) {
      this.footerCode = code;
    },
    async onSubmit() {
      this.loading = true;

      try {
        await this.updateVesselData();
        $.notify('Changes have been saved.', 'success');
      } catch (error) {
        $.notify('Failed to save the changes.', 'error');
      }

      this.loading = false;
    },
    async updateVesselData() {
      const vesselChanges = {};
      if (this.headerCode !== this.vesselHeaderCode) {
        vesselChanges.custom_scripts_head = this.headerCode;
      }
      if (this.footerCode !== this.vesselFooterCode) {
        vesselChanges.custom_scripts_footer = this.footerCode;
      }

      await updateVessel(vesselChanges);
      this.vessel = {...this.vessel, ...vesselChanges};
    },
  },
  watch: {
    vesselHeaderCode(code) {
      this.headerCode = code;
    },
    vesselFooterCode(code) {
      this.footerCode = code;
    },
  },
  async created() {
    this.vessel = await getVessel();
  },
};
</script>

<style lang="scss" scoped>
form {
  max-width: 640px;
}

.loading-image {
  display: inline-block;
  margin-right: 5px;
  width: 20px;
}
</style>
